<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="page-tabs">
      <template v-for="(item, index) in rows">
        <a
          :key="item.index"
          :class="{ active: currentTab === index }"
          @click.prevent="currentTab = index"
          href="#"
        >
          {{ item.title }}
        </a>
      </template>
    </div>

    <div class="page-tabs-content">
      <ValidationObserver v-slot="{ handleSubmit }">
        <div v-for="(item, index) in rows" :key="item.index">
          <table class="table" v-if="currentTab === index">
            <tbody>
              <tr v-for="data in item.content" :key="data.index">
                <th id="mail">
                  {{ data.Item }}
                  <!-- Gmail信件收集履歷 -->
                  <span
                    v-if="data.Item === 'Gmail信件收集履歷'"
                    class="explanation"
                    data-toggle="modal"
                    data-target="#gmailExplanationModal"
                  >
                    ?
                  </span>
                  <!-- O365信件收集履歷 -->
                  <span
                    v-if="data.Item === 'O365信件收集履歷'"
                    class="explanation"
                    data-toggle="modal"
                    data-target="#officeExplanationModal"
                  >
                    ?
                  </span>
                </th>
                <!-- 字串格式 -->
                <td v-if="data.DataType === 'String'">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="data.Value"
                  />
                </td>
                <!-- 密碼格式 -->
                <td v-if="data.DataType === 'Password'">
                  <input
                    type="password"
                    class="form-control"
                    v-model.trim="data.Value"
                  />
                </td>
                <!-- 數字格式 -->
                <td v-if="data.DataType === 'Int'">
                  <el-input-number
                    class="w-100"
                    :min="1"
                    :max="99999"
                    @blur="!data.Value ? (data.Value = 1) : null"
                    v-model="data.Value"
                  />
                </td>
                <!-- 開關格式 -->
                <td v-if="data.DataType === 'Bool'">
                  <el-radio v-model="data.Value" label="true">
                    {{ i18n("Basic.On") }}
                  </el-radio>
                  <el-radio v-model="data.Value" label="false">
                    {{ i18n("Basic.Off") }}
                  </el-radio>
                </td>
                <!-- 上傳格式 -->
                <td v-if="data.DataType === 'Img'">
                  <el-upload
                    class="upload-demo"
                    action
                    accept="image/jpeg,image/png"
                    :auto-upload="false"
                    :show-file-list="false"
                    list-type="picture"
                    :on-change="uploadFile"
                    v-model="data.Value"
                  >
                    <!-- 首頁背景圖片 -->
                    <el-button
                      v-if="
                        data.Guid === '606190f5-7c43-ec11-876a-00155d014913'
                      "
                      size="small"
                      type="primary"
                      @click="clickUpload('homepage')"
                    >
                      上傳圖片
                    </el-button>
                    <!-- 公司LOGO(適用淺色背景) -->
                    <el-button
                      v-if="
                        data.Guid === 'b27958b4-744b-4655-950e-1d819bf24a2a'
                      "
                      size="small"
                      type="primary"
                      @click="clickUpload('dark')"
                    >
                      上傳圖片
                    </el-button>
                    <!-- 公司LOGO(適用深色背景) -->
                    <el-button
                      v-if="
                        data.Guid === 'b27958b4-744b-4655-950e-1d819bf24a2b'
                      "
                      size="small"
                      type="primary"
                      @click="clickUpload('light')"
                    >
                      上傳圖片
                    </el-button>
                    <div slot="tip" class="el-upload__tip mark">
                      僅能上傳 jpg/png 檔案，且大小不超過10MB
                    </div>
                  </el-upload>
                  <img
                    style="width: 120px; height: 120px"
                    :src="data.ImgBase64"
                    alt=""
                  />
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="handleSubmit(editConfig(item))"
                  >
                    {{ i18n("Buttons.Save") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ValidationObserver>
    </div>

    <!-- Gmail信件收集履歷 Modal -->
    <div
      class="modal fade"
      id="gmailExplanationModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
          <div class="modal-header">Gmail串接說明</div>
          <div class="modal-body">
            <img
              style="width: 100%"
              src="@/assets/img/explan/gmail/m_explan_01.jpg"
              alt=""
            />
            <br />
            <br />

            <img
              style="width: 100%"
              src="@/assets/img/explan/gmail/m_explan_02.jpg"
              alt=""
            />
            <br />
            <br />

            <img
              style="width: 100%"
              src="@/assets/img/explan/gmail/m_explan_03.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <!-- O365信件收集履歷 Modal -->
    <div
      class="modal fade"
      id="officeExplanationModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
          <div class="modal-header">Microsoft Graph API</div>
          <div class="modal-body">
            <img
              style="width: 100%"
              src="@/assets/img/explan/office/Microsoft Graph API (Email)-1.jpg"
              alt=""
            />
            <br />
            <br />

            <img
              style="width: 100%"
              src="@/assets/img/explan/office/Microsoft Graph API (Email)-2.jpg"
              alt=""
            />
            <br />
            <br />

            <img
              style="width: 100%"
              src="@/assets/img/explan/office/Microsoft Graph API (Email)-3.jpg"
              alt=""
            />

            <br />
            <br />

            <img
              style="width: 100%"
              src="@/assets/img/explan/office/Microsoft Graph API (Email)-4.jpg"
              alt=""
            />

            <br />
            <br />

            <img
              style="width: 100%"
              src="@/assets/img/explan/office/Microsoft Graph API (Email)-5.jpg"
              alt=""
            />

            <br />
            <br />

            <img
              style="width: 100%"
              src="@/assets/img/explan/office/Microsoft Graph API (Email)-6.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";

export default {
  name: "ParameterSetting",

  data() {
    return {
      currentTab: 0,

      // data
      rows: [],

      // 首頁下方背景圖
      homepageBackground: "",
      // 深色LoGo
      logoDark: "",
      // 淺色LoGo
      logoLight: "",

      // 上傳類型
      uploadType: "",
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // 取得 系統設定參數
    getConfig() {
      this.updateLoading(true);
      this.$api.configSetting.getSystemConfig().then((response) => {
        if (response.status === 200) {
          let arr = [];
          arr = Object.keys(response.data);
          for (const title of arr) {
            this.rows.push({
              title,
              content: response.data[title],
            });
          }
        }
        this.updateLoading(false);
      });
    },

    // 修改 系統設定參數
    editConfig(rows) {
      this.updateLoading(true);
      this.fileGroupGuid = "";

      let guid = [],
        value = [];
      rows.content.forEach((item) => {
        guid.push(item.Guid);
        if (item.Guid === "606190f5-7c43-ec11-876a-00155d014913") {
          // 首頁下方背景圖
          this.homepageBackground === ""
            ? value.push(item.Value)
            : value.push(this.homepageBackground);
        } else if (item.Guid === "b27958b4-744b-4655-950e-1d819bf24a2a") {
          // 公司LOGO(適用淺色背景)
          this.logoDark === ""
            ? value.push(item.Value)
            : value.push(this.logoDark);
        } else if (item.Guid === "b27958b4-744b-4655-950e-1d819bf24a2b") {
          // 公司LOGO(適用深色背景)
          this.logoLight === ""
            ? value.push(item.Value)
            : value.push(this.logoLight);
        } else {
          value.push(item.Value);
        }
      });

      this.$api.configSetting
        .putSystemConfig({
          Guid: guid,
          Value: value,
          UpdateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "編輯成功",
              type: "success",
              duration: 2000,
            });
          }
          this.updateLoading(false);
        });
    },

    // 上傳 檔案
    uploadFile(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$notify({
          title: "失敗",
          message: "檔案大小不得超過10MB",
          type: "error",
          duration: 3500,
        });
        return false;
      }

      this.updateLoading(true);

      let fileGroupGuid;
      switch (this.uploadType) {
        case "homepage":
          fileGroupGuid = this.homepageBackground;
          break;
        case "dark":
          fileGroupGuid = this.logoDark;
          break;
        case "light":
          fileGroupGuid = this.logoLight;
          break;
      }

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);
          switch (this.uploadType) {
            case "homepage":
              this.homepageBackground = response.data;
              break;
            case "dark":
              this.logoDark = response.data;
              break;
            case "light":
              this.logoLight = response.data;
              break;
          }
          this.$notify({
            title: "成功",
            message: "上傳成功",
            type: "success",
            duration: 3500,
          });
        }
      });
    },

    // 點擊上傳圖片按鈕
    clickUpload(category) {
      this.uploadType = category;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getConfig();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
